import { SearchQueryOrderDirection } from "types/generated";

export const SCAN_RESOURCES_FILTERS_TYPE = "scanResources";

export enum ScanResourcesFilterItemKeys {
  NAME = "name",
  TYPE = "type",
  MANAGED = "managed",
}

export const SCAN_RESOURCES_FILTER_ITEMS_DICTIONARY: Partial<
  Record<ScanResourcesFilterItemKeys, string>
> = {
  [ScanResourcesFilterItemKeys.NAME]: "name",
  [ScanResourcesFilterItemKeys.TYPE]: "type",
  [ScanResourcesFilterItemKeys.MANAGED]: "managed",
};

export const SCAN_RESOURCES_INITIAL_SORT_OPTION = ScanResourcesFilterItemKeys.NAME;
export const SCAN_RESOURCES_INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;
